import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { VehicleCargo } from 'src/app/core/interfaces/vehicle-cargo';
import { Utils } from 'src/app/core/resources/utils';
import { Router } from '@angular/router';
import { MenuServiceService } from '../../menu-service/menu-service.service';
import { MenuServiceComponent } from '../../menu-service/menu-service.component';
import { Subscription } from 'rxjs';
import { Fmt } from 'src/app/core/messages/fmt';
import { ServiceResources } from '../../resources/services';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { VehicleAlias } from 'src/app/core/interfaces/vehicleAlias';
import { ManualCreationCargoService } from 'src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service';
import { vehicleAxles } from 'src/app/core/resources/vehicleAxles';
@Component({
  selector: 'app-vehicle-service-form',
  templateUrl: './vehicle-service-form.component.html',
  styleUrls: ['./vehicle-service-form.component.scss']
})
export class VehicleServiceFormComponent implements OnInit {
  permission = Permission;
  // Vehicle Alias Controls
  vehicleAliasControl: FormControl = new FormControl('');
  vehicleAliases: VehicleAlias[] = [];
  // Vehicle Controls
  vehicleTypeControl: FormControl = new FormControl('', Validators.required);
  optionsTypeVehicle: OptionsAutocomplete = {
    showAutocomplete: true,
    title: 'Tipo de vehiculo',
    appearance: 'outline',
  };
  // Bodywork Controls
  bodyworkTypeControl: FormControl = new FormControl('', Validators.required);
  optionsBodyworkType: OptionsAutocomplete = {
    title: 'Tipo de carrocería',
    appearance: 'outline',
  }
  // Environment Controls
  environmentControl: FormControl = new FormControl('', Validators.required);
  environments = [
    { label: 'Seco', value: 'Seco' },
    { label: 'Refrigerado', value: 'Refrigerado' },
    { label: 'Congelado', value: 'Congelado' }
  ];
  //Axles Controls
  minAxles: number = 2;
  axlesControl: FormControl = new FormControl('', [Validators.required, Validators.min(this.minAxles)]);
  //Trailer Controls
  trailerBodyworkControl: FormControl = new FormControl('');
  optionsTrailerBodyworkType: OptionsAutocomplete = {
    title: 'Tipo de carrocería del tráiler',
    appearance: 'outline',
    initialVehicleTypeId: '41'
  }
  trailerAxlesControl: FormControl = new FormControl('', [Validators.min(this.minAxles)]);

  formValidate = '';
  subscriptions: Subscription = new Subscription();
  isDialog: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public paramsDialog: { cargo: Cargo },
    public dialogRef: MatDialogRef<VehicleServiceFormComponent>,
    public utils: Utils,
    public menuService: MenuServiceService,
    private router: Router,
    private serviceResources: ServiceResources,
    private snackBarService: SnackBarService,
    private permissionRole: PermissionRole,
    private cargoManager: CargoManager,
    private manualCreationCargoService: ManualCreationCargoService
  ) { }

  async ngOnInit() {
    await this.checkDialogParams();
    this.getVehicleAliases();
    this.setLocalValues();
    this.setSubscription();
    this.checkPermissionsToEdit();
  }

  private async checkDialogParams() {
    if (this.paramsDialog && this.paramsDialog.cargo) {
      this.isDialog = true;
      this.menuService.cargo = this.paramsDialog.cargo;
      this.menuService.patchForm(this.paramsDialog.cargo, false);
      await this.menuService.setCargoConsignments();
      await this.menuService.setCargoVehicle();
    }
  }

  private async getVehicleAliases() {
    try {
      const vehicleAliases = await this.manualCreationCargoService.getVehicleAliases().toPromise();
      this.vehicleAliases = vehicleAliases && vehicleAliases.length ? vehicleAliases.sort((a, b) => a.name.localeCompare(b.name)) : [];
    } catch (error) {
      this.vehicleAliases = [];
    }
  }

  private setLocalValues() {
    if (this.menuService.form.get('cargoFeature.vehicleType.vehicleAlias').value)
      this.vehicleAliasControl.setValue({ name: this.menuService.form.get('cargoFeature.vehicleType.vehicleAlias').value });
    if (this.menuService.form.get('cargoFeature.vehicleType.quality').value)
      this.environmentControl.setValue(this.menuService.form.get('cargoFeature.vehicleType.quality').value);
    if (this.menuService.form.get('axles').value)
      this.axlesControl.setValue(Number(this.menuService.form.get('axles').value));
    const vehicleType = this.menuService.form.get('cargoFeature.vehicleType.name').value;
    const bodyWorkType = this.menuService.form.get('cargoFeature.vehicleType.bodyWorkType.name').value;
    if (vehicleType) {
      this.optionsTypeVehicle = { ...this.optionsTypeVehicle, initialValue: vehicleType };
      this.vehicleTypeControl.setValue({ name: vehicleType });
    }
    if (bodyWorkType || vehicleType)
      this.optionsBodyworkType = { ...this.optionsBodyworkType, initialValue: bodyWorkType, initialVehicleTypeName: vehicleType };
    if (bodyWorkType)
      this.bodyworkTypeControl.setValue({ name: bodyWorkType });
    const trailerBodyworkType = this.menuService.form.get('cargoFeature.vehicleType.trailer.bodywork').value;
    if (trailerBodyworkType) {
      this.trailerBodyworkControl.setValue({ name: trailerBodyworkType });
      this.optionsTrailerBodyworkType = { ...this.optionsTrailerBodyworkType, initialValue: trailerBodyworkType };
    }
    if (this.menuService.form.get('cargoFeature.vehicleType.trailer.axles').value)
      this.trailerAxlesControl.setValue(this.menuService.form.get('cargoFeature.vehicleType.trailer.axles').value);
  }

  private setSubscription() {
    this.subscriptions.add(this.vehicleAliasControl.valueChanges.subscribe(event => this.onSelectVehicleAlias(event)));
    this.subscriptions.add(this.vehicleTypeControl.valueChanges.subscribe(value => this.onSelectVehicleType(value)));
    this.subscriptions.add(this.bodyworkTypeControl.valueChanges.subscribe(() => this.onSelectBodyworkType()));
    this.subscriptions.add(this.menuService.formObservable.subscribe(() => this.setLocalValues()));
  }

  onSelectVehicleAlias(event: MatSelectChange) {
    const selectedAlias: VehicleAlias = event.value;
    if (selectedAlias) {
      this.vehicleTypeControl.setValue(selectedAlias.vehicleType);
      this.optionsTypeVehicle['initialValue'] = selectedAlias.vehicleType.name;
      this.optionsTypeVehicle = { ...this.optionsTypeVehicle };
      this.axlesControl.setValue(selectedAlias.axles);
    }
  }

  private onSelectVehicleType(vehicle: VehicleCargo) {
    if (!vehicle) return;
    this.optionsBodyworkType = {
      ...this.optionsBodyworkType,
      initialVehicleTypeId: vehicle.id,
      initialVehicleTypeName: vehicle.name,
      initialValue: ""
    };
    this.bodyworkTypeControl.setValue("");
    if (vehicleAxles[vehicle.name])
      this.axlesControl.setValue(vehicleAxles[vehicle.name]);
    const vehicleAlias: VehicleAlias = this.vehicleAliasControl.value;
    const vehicleAliasOption = this.vehicleAliases.find(alias => alias && vehicleAlias && alias.name === vehicleAlias.name);
    if (vehicleAliasOption && vehicleAliasOption.vehicleType && vehicleAliasOption.vehicleType.name !== vehicle.name)
      this.vehicleAliasControl.setValue(null);
  }

  public onChangeVehicleAxles(event: Event): void {
    const value: number = parseInt((event.target as HTMLInputElement).value);
    const vehicleAlias: VehicleAlias = this.vehicleAliasControl.value;
    if (vehicleAlias && vehicleAlias.axles !== value)
      this.vehicleAliasControl.setValue(null);
  }

  private onSelectBodyworkType(): void {
    this.trailerBodyworkControl.setValue(null);
    this.trailerAxlesControl.setValue(null);
  }

  private checkPermissionsToEdit() {
    if (!this.canEditVehicleService) {
      this.formValidate = 'disable';
      this.vehicleTypeControl.disable();
      this.bodyworkTypeControl.disable();
      this.environmentControl.disable();
      this.axlesControl.disable();
      this.trailerBodyworkControl.disable();
      this.trailerAxlesControl.disable();
      this.vehicleAliasControl.disable();
    }
  }

  get canEditVehicleService(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.editTypeVehicle
    );
  }

  get showEnvironmentControl(): boolean {
    const vehicleType = this.utils.getNestedValue(this.vehicleTypeControl.value, 'name');
    const bodyWorkType = this.utils.getNestedValue(this.bodyworkTypeControl.value, 'name');
    return this.cargoManager.requestEnvironmentType(vehicleType, bodyWorkType);
  }

  get showAxlesControl(): boolean {
    const vehicleType = this.utils.getNestedValue(this.vehicleTypeControl.value, 'name');
    return vehicleType && !vehicleAxles[vehicleType];
  }

  get showTrailerInfo(): boolean {
    const vehicleType = this.utils.getNestedValue(this.vehicleTypeControl.value, 'name');
    const bodyWorkType = this.utils.getNestedValue(this.bodyworkTypeControl.value, 'name');
    return vehicleType && vehicleType === 'TRACTOCAMION' && bodyWorkType && bodyWorkType !== 'GRUA';
  }

  compareWithVehicleAlias(option: VehicleAlias, value: VehicleAlias): boolean {
    return option.name === value.name;
  }

  backToPreviousStep() {
    this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.destination, this.menuService.cargo.consecutive)]);
  }

  private isValidForm(): boolean {
    if (this.utils.errorMessagesCustomized(this.vehicleTypeControl, 'tipo de vehiculo')) return false;
    if (this.utils.errorMessagesCustomized(this.bodyworkTypeControl, 'tipo de carroceria')) return false;
    if (this.showEnvironmentControl && this.utils.errorMessagesCustomized(this.environmentControl, 'tipo de ambiente')) return false;
    if (this.showAxlesControl && this.utils.errorMessagesCustomized(this.axlesControl, 'número de ejes', null, null, this.minAxles)) return false;
    if (this.showTrailerInfo && this.utils.errorMessagesCustomized(this.trailerBodyworkControl, 'tipo de carrocería del tráiler')) return false;
    if (this.showTrailerInfo && this.utils.errorMessagesCustomized(this.trailerAxlesControl, 'número de ejes del tráiler', null, null, this.minAxles)) return false;
    return true;
  }

  saveAndContinue() {
    if (this.isDialog && !this.isValidForm()) return;
    const vehicleAlias = this.vehicleAliasControl.value ? this.vehicleAliasControl.value.name : '';
    this.menuService.form.get('cargoFeature.vehicleType.vehicleAlias').setValue(vehicleAlias);
    this.menuService.form.get('cargoFeature.vehicleType.quality').setValue(this.showEnvironmentControl ? this.environmentControl.value : '');
    this.menuService.form.get('axles').setValue(this.axlesControl.value ? Number(this.axlesControl.value) : '');
    const vehicleType = this.vehicleTypeControl.value && this.vehicleTypeControl.value.name ? this.vehicleTypeControl.value.name : '';
    this.menuService.form.get('cargoFeature.vehicleType.name').setValue(vehicleType);
    const bodyWorkType = this.bodyworkTypeControl.value && this.bodyworkTypeControl.value.name ? this.bodyworkTypeControl.value.name : '';
    this.menuService.form.get('cargoFeature.vehicleType.bodyWorkType.name').setValue(vehicleType ? bodyWorkType : '');
    this.menuService.form.get('cargoFeature.vehicleType.trailer.bodywork').setValue(this.showTrailerInfo && this.trailerBodyworkControl.value ? this.trailerBodyworkControl.value.name : '');
    this.menuService.form.get('cargoFeature.vehicleType.trailer.axles').setValue(this.showTrailerInfo && this.trailerAxlesControl.value ? Number(this.trailerAxlesControl.value) : '');
    this.menuService.updateService().then(() => {
      this.snackBarService.openSnackBar('Servicio actualizado exitosamente');
      if (!this.isDialog) this.continueToNextStep();
      else this.dialogRef.close({ state: true });
    }).catch(() => this.snackBarService.openSnackBar('Ocurrió un error al actualizar el servicio', undefined, 'error'));
  }

  continueToNextStep() {
    if (this.menuService.isEscortedService()) return this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.escortedVehicle, this.menuService.cargo.consecutive)]);
    const isRequiredLoadTypeService = this.menuService.isRequiredLoadTypeService();
    this.router.navigate([Fmt.string(isRequiredLoadTypeService
      ? this.serviceResources.serviceRequestUrls.cargoType
      : this.serviceResources.serviceRequestUrls.loadCharacteristics, this.menuService.cargo.consecutive)]);
  }

  ngOnDestroy() {
    if (this.subscriptions) this.subscriptions.unsubscribe();
  }
}
